/**
 * Product-page Gallery tab — populate "cars running this wheel" from the FULL
 * vehicle-gallery manifest (assets/gallery-data.json), client-side.
 *
 * Why: the Liquid version matched inside a `paginate ... by 250` block, so it
 * only ever saw the first 250 of ~2,580 gallery entries — most products showed
 * few/none. The manifest holds every entry with a `wheel` field, so we match
 * against all of them here. Matching rule mirrors the Liquid one (the product's
 * model name contains the entry's wheel name, case-insensitive).
 *
 * - Matches found: the images link to that build's gallery entry, and clicking a
 *   thumbnail previews it (main image) and re-points the link.
 * - No matches: show a "no builds yet" message instead of the server fallback.
 */
(function () {
  'use strict';

  var MAX = 12; // cars to show in the tab; "View More" links to the full gallery
  var EMPTY_MSG = 'No cars in our gallery are running this wheel yet — check back soon, or <a href="/pages/submit-ride" class="gtu-product__gallery-empty-link" style="color:#DC2028;text-decoration:underline;">be the first to submit yours</a>!';
  var EMPTY_STYLE = 'padding:48px 24px;text-align:center;color:#9a9a9a;font-size:16px;line-height:1.5;';

  function imgUrl(u, w) {
    if (!u) return u;
    return u.indexOf('?') === -1 ? u + '?width=' + w : u.replace(/([?&])width=\d+/, '$1width=' + w);
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function build(gallery, matches) {
    var main = gallery.querySelector('#gallery-main-image');
    var thumbs = gallery.querySelector('#gallery-thumbnails');
    var carousel = document.getElementById('lifestyle-carousel');
    if (!main || !thumbs) return;

    // Main image = first match, wrapped in a link to that build's gallery entry.
    main.innerHTML =
      '<a class="gtu-product__photo-link" href="' + esc(matches[0].url || '#') + '" title="View this build in the gallery">' +
      '<img src="' + imgUrl(matches[0].image_url, 800) + '" alt="' + esc(matches[0].image_alt || matches[0].title) + '" loading="lazy"></a>';
    var mainLink = main.querySelector('a');
    var mainImg = main.querySelector('img');

    // Thumbnails (clicking one previews it in the main image + re-points the link)
    thumbs.innerHTML = matches.map(function (m, i) {
      return (
        '<button class="gtu-product__photo-thumb' + (i === 0 ? ' is-active' : '') + '"' +
        ' data-index="' + i + '" data-src="' + imgUrl(m.image_url, 800) + '"' +
        ' data-alt="' + esc(m.image_alt || m.title) + '" data-url="' + esc(m.url || '') + '">' +
        '<img src="' + imgUrl(m.image_url, 300) + '" alt="' + esc((m.title || '') + ' thumbnail') + '" loading="lazy"></button>'
      );
    }).join('');

    var tbtns = thumbs.querySelectorAll('.gtu-product__photo-thumb');
    tbtns.forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg && t.dataset.src) { mainImg.src = t.dataset.src; mainImg.alt = t.dataset.alt || ''; }
        if (mainLink && t.dataset.url) mainLink.href = t.dataset.url;
        tbtns.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    // Mobile lifestyle carousel — images link to the build too.
    if (carousel) {
      carousel.innerHTML = matches.map(function (m, i) {
        return (
          '<div class="gtu-product__lifestyle-slide' + (i === 0 ? ' is-active' : '') + '" data-caption="' + esc(m.title || '') + '">' +
          '<a class="gtu-product__lifestyle-link" href="' + esc(m.url || '#') + '"><div class="gtu-product__lifestyle-image"><img src="' +
          imgUrl(m.image_url, 800) + '" alt="' + esc(m.title || '') + '" loading="lazy"></div></a></div>'
        );
      }).join('');
    }
  }

  // No cars run this wheel yet -> show a message instead of the product-image fallback.
  function showEmpty(gallery) {
    var main = gallery.querySelector('#gallery-main-image');
    var thumbs = gallery.querySelector('#gallery-thumbnails');
    var carousel = document.getElementById('lifestyle-carousel');
    var msg = '<div class="gtu-product__gallery-empty" style="' + EMPTY_STYLE + '">' + EMPTY_MSG + '</div>';
    if (main) main.innerHTML = msg;
    if (thumbs) thumbs.innerHTML = '';
    if (carousel) carousel.innerHTML = msg;
  }

  function init() {
    var gallery = document.querySelector('.gtu-product__tab-panel[data-panel="gallery"] .gtu-product__photo-gallery');
    if (!gallery) return;
    var model = (gallery.getAttribute('data-wheel-model') || '').trim().toLowerCase();
    var handle = (gallery.getAttribute('data-product-handle') || '').trim();
    if (!model) return;
    var url = window.GTU_GALLERY_DATA_URL;
    if (!url) return;

    fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var rows = Array.isArray(data) ? data : (data.entries || []);
        // Exact matches first: the gallery's wheel name maps to THIS product's handle (or the
        // product is its picked 2nd wheel) — survives product title changes (e.g. CF3C).
        // Related builds (model name contains the wheel name, the original rule) fill the rest,
        // so no page shows fewer builds than before.
        var hz = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); };
        var exact = [], related = [];
        rows.forEach(function (e) {
          if (!e.image_url) return;
          var w = (e.wheel || '').trim().toLowerCase();
          var w2 = (e.wheel2 || '').trim().toLowerCase();
          if (handle && ((e.wheel_handle || hz(e.wheel)) === handle || e.wheel2_handle === handle)) exact.push(e);
          else if ((w && model.indexOf(w) !== -1) || (w2 && model.indexOf(w2) !== -1)) related.push(e);
        });
        var matches = exact.concat(related).slice(0, MAX);
        if (matches.length) build(gallery, matches);
        else showEmpty(gallery);
      })
      .catch(function () { /* leave server fallback on network error */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
